import InfoOutlined from '@mui/icons-material/InfoOutlined';
import { FixMe } from '@greenkub-fronts/shared/interface';

export function InfoOutlinedIcon(props: FixMe) {
  return <InfoOutlined {...props} />;
}

export default InfoOutlinedIcon;
